var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { on: { keyup: _vm.keyPressed } },
    [
      _c("label", [_vm._v("\n        " + _vm._s(_vm.fieldLabel) + "\n    ")]),
      _vm._v(" "),
      _vm.fieldType === "markdown"
        ? _c("markdown-editor", {
            ref: "inputField",
            staticClass: "editor",
            attrs: { toolbar: "" },
            on: { input: _vm.handleInput },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          })
        : _vm.fieldType !== "textarea"
        ? _vm.fieldType === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.content,
                  expression: "content",
                },
              ],
              ref: "inputField",
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.content)
                  ? _vm._i(_vm.content, null) > -1
                  : _vm.content,
              },
              on: {
                input: _vm.handleInput,
                change: function ($event) {
                  var $$a = _vm.content,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.content = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.content = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.content = $$c
                  }
                },
              },
            })
          : _vm.fieldType === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.content,
                  expression: "content",
                },
              ],
              ref: "inputField",
              attrs: { type: "radio" },
              domProps: { checked: _vm._q(_vm.content, null) },
              on: {
                input: _vm.handleInput,
                change: function ($event) {
                  _vm.content = null
                },
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.content,
                  expression: "content",
                },
              ],
              ref: "inputField",
              attrs: { type: _vm.fieldType },
              domProps: { value: _vm.content },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.content = $event.target.value
                  },
                  _vm.handleInput,
                ],
              },
            })
        : _vm._e(),
      _vm._v(" "),
      _vm.fieldType === "textarea"
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.content,
                expression: "content",
              },
            ],
            ref: "inputField",
            domProps: { value: _vm.content },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.content = $event.target.value
                },
                _vm.handleInput,
              ],
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }